import React from 'react';
import { RouteProps, Route as ReactDOMRoute, Redirect } from 'react-router-dom';

import { useAuth } from '../context/auth';
import Layout from '../components/Layout';

interface RouteInterface extends RouteProps {
  isPrivate?: boolean;
  noLayout?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteInterface> = ({
  isPrivate = false,
  noLayout,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <>
            {noLayout || !isPrivate ? (
              <Component />
            ) : (
              <Layout>
                <Component />
              </Layout>
            )}
          </>
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/login' : '/',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
